var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-expansion-panels',[(_vm.hasGrants)?_c('app-grants-production',{attrs:{"id":_vm.id}}):_vm._e(),_vm._v(" "),(_vm.hasPublications)?_c('app-publications-production',{attrs:{"id":_vm.id}}):_vm._e(),_vm._v(" "),(_vm.hasLectures)?_c('app-lecture-production',{attrs:{"id":_vm.id}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }